import { render, staticRenderFns } from "./EnvioDespachoDetalleComponent.vue?vue&type=template&id=0fff2118&"
import script from "./EnvioDespachoDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./EnvioDespachoDetalleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports